module.exports = __webpack_public_path__ + "static/media/Dr_Salim_Headset.999fa2b1.png";